import {isPlatformBrowser} from "@angular/common";
import {DOCUMENT, inject, Injectable, PLATFORM_ID, signal} from "@angular/core";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class GoogleApiServices {

  private readonly document = inject(DOCUMENT);

  private readonly platformId = inject(PLATFORM_ID)

  public apiKeyReady = signal(false);

  async initScript() {
    if (!isPlatformBrowser(this.platformId) || this.document.getElementById('maps-api-tag')) return;

    // Script
    const script = this.document.createElement('script');
    script.id = 'maps-api-tag';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googlePlaceApiKey}&loading=async&libraries=places`;

    this.document.head.appendChild(script);

    await new Promise(res => setTimeout(res, 50));

    this.apiKeyReady.set(true)
  }
}
